<template>
  <v-row justify="center">
    <v-dialog :value="value" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{localization.historico.titulo}}</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="!detalle">
            <!-- datatable con datos de ejemplo-->
            <v-data-table
              :headers="headers"
              :items="items"
              :items-per-page="5"
              class="elevation-1"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align:center">{{ item.nombre }}</td>
                  <td style="text-align:center">{{ item.documentos.length }}</td>
                  <td style="text-align:center">{{ convertirFecha(item.fechaAlta) }}</td>
                  <td style="text-align:center">
                    <v-btn icon @click="verHistorico(item)">
                      <v-icon color="primary">mdi-eye</v-icon>
                    </v-btn>
                    <!-- borrar-->
                    <v-btn icon @click="borrarHistorico(item)">
                      <v-icon color="error">mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

          </v-container>


          <v-container v-if="detalle">
            <!-- datatable con datos de ejemplo-->
            <v-data-table
              :headers="headersDetalle"
              :items="itemsDetalle"
              :items-per-page="5"
              class="elevation-1"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align:center">{{ item.nombre }}</td>
                  <td style="text-align:center">{{ getObjeto(item) }}</td>
                </tr>
              </template>
            </v-data-table>
            <!-- boton de volver a !detalle -->
          </v-container>
          
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <!--<v-btn color="primary" @click.native="enviado ? $emit('reload') : null; vaciar(); $emit('input');">{{localization.cerrar}}</v-btn>-->

            <v-btn v-if="detalle" color="primary" class="mr-2" @click.native="detalle = false">{{localization.historico.volver}}</v-btn>
            <v-btn color="primary" @click.native="$emit('close');">{{localization.cerrar}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <ConfirmDialog 
      :text="localization.historico.confirmacionBorrar"
      @close="confirmarBorrarHistorico()" 
      @cancel="dialogBorrar = false; "
      :dialogFlag="dialogBorrar" 
      :textoBoton="localization.historico.confirmar" 
      textoTitulo="" />
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import rulesMixin from '@/components/generic/rules.js'

import ConfirmDialog from '@/components/custom/confirmDialog'

export default {
  mixins: [rulesMixin],
  components: {
    ConfirmDialog
  },
  props: {
    value: Boolean,
    singleItem: Array
  },
  data () {
    return {
      items: [],
      detalle: false,
      dialogBorrar: false,
      itemSeleccionado: false
    }
  },
  async created () {
    let documentos = await this.getHistorico()
    this.items = documentos.data
  },
  computed: {
    localization () {
      return this.$t('formImportarDocumentos')
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    headers () {
      return [
        { text: this.$t('formImportarDocumentos.historico.nombre'), sortable: true, align: 'center' },
        { text: this.$t('formImportarDocumentos.historico.documentos'), sortable: true, align: 'center' },
        { text: this.$t('formImportarDocumentos.historico.fecha'), sortable: true, align: 'center' },
        { text: this.$t('formImportarDocumentos.historico.acciones'), sortable: true, align: 'center' }
      ]
    },
    headersDetalle() {
      return [
        { text: this.$t('formImportarDocumentos.historico.nombre'), sortable: true, align: 'center' },
        { text: this.$t('formImportarDocumentos.historico.objeto'), sortable: true, align: 'center' }
      ]
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getRootState: 'gestion/getRootState',
      getHistorico: 'incidencias/getHistorico',
      deleteHistorico: 'incidencias/deleteHistorico'
    }),
    convertirFecha(fecha) {
      // viene asi 	2024-07-17 12:59:06
      return moment(fecha).format('DD/MM/YYYY HH:mm')
    },
    getObjeto(item) {
      if (item.tipoObjetoId == 3) {
        return `Visita ${item.referencia}`
      } else if (item.tipoObjetoId == 2) {
        return `Incidencia ${item.referencia}`
      }
      return ''
    },
    borrarHistorico(item) {
      // pedimos confirmacion
      this.itemSeleccionado = item
      this.dialogBorrar = true
    },
    async confirmarBorrarHistorico() {
      
      let res = await this.deleteHistorico({
        id: this.itemSeleccionado.id
      })
      if (res.status == 200) {
        this.addAlert({ texto: this.$t('formImportarDocumentos.historico.borradoCorrecto'), color: 'success' })
        this.items = this.items.filter(item => item.id != this.itemSeleccionado.id)
        this.dialogBorrar = false
      } else {
        this.addAlert({ color: 'error', texto: this.$t('formImportarDocumentos.historico.borradoError') })
        this.dialogBorrar = false
      }

    },
    
    verHistorico(item) {
      this.detalle = true
      this.itemsDetalle = item.documentos
    }
  },
  watch: {
    async value(value) {
      if (value) {
        let documentos = await this.getHistorico()
        this.items = documentos.data
      }
    }
  }
}
</script>

<style scoped>

</style>
